import React from 'react'

function Websites() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Website Designing</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Website Designing</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                We create visually stunning, responsive, and SEO-optimized websites to grow your business online.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Website Designing" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Feature Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Bluevipers</div>
              <h1 className="text-white mb-4">Professional Website Designing with Modern Technologies</h1>
              <p className="text-light mb-5">
                At Bluevipers Technology, we build websites tailored to your business goals. 
                Responsive design, SEO optimization, and user-friendly interfaces ensure a premium digital presence.
              </p>
            </div>

            {/* Features */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-primary rounded p-4 h-100">
                <i className="fa fa-mobile fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">Responsive Design</h5>
                  <p className="text-white-50 mb-0">Websites that look perfect on any device.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-success rounded p-4 h-100">
                <i className="fa fa-search fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">SEO Optimization</h5>
                  <p className="text-white-50 mb-0">Improving visibility on Google and other search engines.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="d-flex align-items-start bg-warning rounded p-4 h-100">
                <i className="fa fa-cogs fa-3x text-white me-3" />
                <div>
                  <h5 className="text-white">Custom Features</h5>
                  <p className="text-white-50 mb-0">Tailored functionality and easy-to-use interfaces.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Feature End */}

      {/* Contact Start */}
      <div className="container-fluid bg-primary py-5">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Contact Us</div>
              <h1 className="text-white mb-4">Get in Touch with Bluevipers Technology</h1>
              <p className="text-white-50 mb-4">
                Call us at <strong>+91 8459432930</strong> or email at <strong>blueviperstechnology@gmail.com</strong>
              </p>
              <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
    </div>
  )
}

export default Websites
